<section class="kayak-shell">
  <header class="kayak-header">
    <div>
      <p class="eyebrow">Account • Integrations</p>
      <h1>Kayak Travel Agent</h1>
      <p class="subtitle">
        Pull the freshest flight deals and push itineraries into your KAYAK Trips flow with a single action.
      </p>
    </div>
    <div>
 
      <!-- <span>{{ errorMessage ? 'Offline' : 'Live' }}</span> -->
       <button type="button" class="premium-gold-btn">
  Premium
</button>
       
    </div>
  </header>

  <div class="kayak-grid">
    <section class="panel">
      <div class="panel-header">
        <h2>Search live deals</h2>
        <button class="primary-btn" (click)="fetchDeals()" [disabled]="isLoading">
          {{ isLoading ? 'Loading…' : 'Refresh deals' }}
        </button>
      </div>

      <form class="search-form" (ngSubmit)="fetchDeals()">
        <label>
          Origin
          <input type="text" formControlName="origin" placeholder="SFO" />
        </label>
        <label>
          Destination
          <input type="text" formControlName="destination" placeholder="JFK" />
        </label>
        <label>
          Depart date
          <input type="date" formControlName="departDate" />
        </label>
        <label>
          Return date
          <input type="date" formControlName="returnDate" />
        </label>
        <label>
          Adults
          <input type="number" min="1" formControlName="adults" />
        </label>
        <button class="secondary-btn" type="submit" [disabled]="isLoading">
          Run KAYAK search
        </button>
      </form>

      <div class="note" *ngIf="responseNote && !errorMessage">
        <strong>API note:</strong> {{ responseNote }}
      </div>
      <div class="error" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
    </section>

    <section class="panel deals-panel">
      <div class="panel-header">
        <h2>Top live results</h2>
        <span class="result-count">{{ deals.length }} deals</span>
      </div>

      <div class="deal-card" *ngFor="let deal of deals">
        <div>
          <h3>{{ deal.route }}</h3>
          <p class="deal-meta">
            {{ deal.airline || 'Multiple carriers' }} · {{ deal.departDate }}
            <span *ngIf="deal.returnDate">→ {{ deal.returnDate }}</span>
          </p>
          <p class="deal-price">{{ deal.price }}</p>
        </div>
        <div class="deal-actions">
          <button class="ghost-btn" type="button" (click)="openKayak(deal)">Open in KAYAK</button>
          <button class="ghost-btn" type="button" (click)="downloadCalendar(deal)">Add to calendar</button>
          <a class="ghost-btn" [href]="getTripsEmailLink(deal)">Email to KAYAK Trips</a>
        </div>
      </div>

      <div class="empty-state" *ngIf="!isLoading && deals.length === 0">
        <h3>No deals yet</h3>
        <p>Run a search to pull the freshest KAYAK prices from the live partner API.</p>
      </div>
    </section>
  </div>

  <section class="panel workflow-panel">
    <h2>How the KAYAK agent works</h2>
    <div class="workflow-grid">
      <div class="workflow-card">
        <h3>Read: Live prices & insights</h3>
        <p>Every search hits the approved KAYAK Flights API to retrieve the latest fares and deep links.</p>
        <ul>
          <li>Two-step intelligent search completion</li>
          <li>Price insights & trend intelligence</li>
          <li>Deal ranking before it reaches the agent</li>
        </ul>
      </div>
      <div class="workflow-card">
        <h3>Write: Trips without friction</h3>
        <p>
          Use “Email to KAYAK Trips” to generate a prefilled confirmation that the user sends from their inbox.
        </p>
        <ul>
          <li>Trips are created via trips@kayak.com</li>
          <li>Works with existing KAYAK trip names</li>
          <li>Calendar export stays in your control</li>
        </ul>
      </div>
      <div class="workflow-card">
        <h3>Agent-ready endpoints</h3>
        <p>All data is coming from your live serverless function, ready for LLM tool calling.</p>
        <ul>
          <li>API Gateway → Lambda runtime</li>
          <li>Structured outputs for query control</li>
          <li>Secure keys in Secrets Manager</li>
        </ul>
      </div>
    </div>
  </section>
</section>
